import * as React from "react"
import { App } from "./app"
import { PADebug, Assert } from "./PADebug"

///////  Reading json files /////////

function GetFromUrl(yourUrl:string) {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("GET", yourUrl, false);
    Httpreq.send(null);
    return Httpreq.responseText;
}

///////////////   TreeViewGW  ////////////////

export interface TreeViewVm  {
    defaultUrl: string
    itemWidth: string
    itemHeight: string
    defaultExpanded: boolean
    app: App
}

interface TreeviewStates {
    treeSource: string
    expandedItemL1: number
    expandedItemL2: number
    expandedItemL3: number
    expandedItemL4: number
    expandedItemL5: number
    showingAtLevel: number
    hasDerivedFromPreviousSelection: boolean
}

/* The TreeViewGW is designed to display cathegories of wares, either nestled in a hierarchy
 * of cathegories and sub cathegories (like nobb in Norway) or as a plain list of cathegories
 * (by using its top level and without using any expandable nodes). TreeViewGW currently supports
 * a hierarchy deapth of up to 5 levels (of which 3 levels are in use in the norwegian setup),
 * though graphics and color settings are currently only made for the first 3 levels, so you'll
 * need to add your own design if you'd like to increase the deapth beyond these three levels.
 * The structure of nodes in the tree is read in from a json file, and the url to that file
 * is stored as an exchangable state in TreeViewGW, which will be changed when selecting a
 * prize book from the dropdown list. These prize books can be found and edited within the
 * items/prizeBooks directory. To properly create such a tree structure you need to fill
 * out these 3 values for each object withing the json file:
    {
      "itemText": "cathegory name",     // This text will be displayed on the tree item
      "level": "1",                     // The level within the hierarchy
      "readingUrl": "url"               // Here you can add an url of your choise, which should
     }                                  // lead to a properly structured json for the articleView.

  /* When entering the level value, 1 means the top level of the hierarchy. As a rule of thumb,
   * do not enter a value higher than the previous item's level plus one. When entering the url,
   * if you instead type in an empty string "" then the tree item will not attempt to make any
   * changes to the article view when clicked, but may still serve as a group of cathegories.   */

export class TreeViewGW extends React.Component<TreeViewVm, TreeviewStates> {

    constructor(props: TreeViewVm) {
        super(props);
        this.m_searchUpdatePending = 0
    }

    state = {
        treeSource: "optimera_nobb", // default
        expandedItemL1: -1, 
        expandedItemL2: -1,
        expandedItemL3: -1,
        expandedItemL4: -1,
        expandedItemL5: -1,
        showingAtLevel: -1,
        hasDerivedFromPreviousSelection: false
    } 

    // Sets the core's reference back to this tree view on initiation 
    componentWillMount() { 
        this.props.app.GetCore().ConnectTreeView(this)
    }

    private m_searchUpdatePending: number

    public PreservePreviousSelection() {
        // If there is a previously selected nobbgroup (chosen from a previously displayed pricegroup) this should
        // be found and selectedby default if a corresponding group can be found in this tree hierarchy..
        if (this.state.hasDerivedFromPreviousSelection == false) {

            var lev1 = -1
            var lev2 = -1
            var lev3 = -1

            /* If the current displaymode is a search result as the user switches pricebook or between
             * nobb and alphabetical mode, the recent search enter will be called again once the changes are
             * made to automatically recive the corresponding result in another prizebook, this will be a
             * process which awaits the corresponding nobb group to be loaded before being called.  */

            this.m_searchUpdatePending = 4
            setTimeout(this.SearchUpdatePulse.bind(this), 200)

            // No selections has yet been made for the first time (no action)
            if (this.props.app.GetCore().GetLastSelectedGroup() == "") {
                this.setState({ hasDerivedFromPreviousSelection: true })
            }

            var prevGrp: string = this.props.app.GetCore().GetLastSelectedGroup()

            if (this.props.app.GetCore().GetTreeIsAlphabetical() == true) {
                var tree = this.props.app.GetCore().GetAlphabeticalGroups(false)

                if (prevGrp.length < 7) {
                    this.setState({ hasDerivedFromPreviousSelection: true })
                    return
                }

                if (tree != undefined) {

                    for (var i = 0; i < tree.length; i++) {
                        const grp = tree[i].GetGroupID()

                        if (grp.length < 7) {
                            break
                        }

                        if (grp.charAt(0) != prevGrp.charAt(0)) {
                            continue
                        }

                        if (grp.charAt(1) != prevGrp.charAt(1)) {
                            continue
                        }

                        if (grp.charAt(2) != prevGrp.charAt(2)) {
                            continue
                        }

                        if (grp.charAt(3) != prevGrp.charAt(3)) {
                            continue
                        }

                        if (grp.charAt(4) != prevGrp.charAt(4)) {
                            continue
                        }

                        if (grp.charAt(5) != prevGrp.charAt(5)) {
                            continue
                        }

                        if (grp.charAt(6) != prevGrp.charAt(6)) {
                            continue
                        }

                        // A matching group has been found
                        lev1 = i
                    }

                    PADebug.Log("TreeView.PreservePreviousSelection - m_searchUpdatePending:" + this.m_searchUpdatePending.toString() + " is set to 12 (upper)")
                    this.m_searchUpdatePending = 12
                    this.setState({ hasDerivedFromPreviousSelection: true, expandedItemL1: lev1, showingAtLevel: 1 })
                }
            }
            else {
                var tree = this.props.app.GetCore().GetHierarchialGroups()
                if (tree != undefined) {

                    var deapth = 0

                    for (var i = 0; i < tree.length; i++) {

                        if ((tree[i].GetLevel() == 1) && (deapth == 0)) {
                            const grp = tree[i].GetGroupID()

                            Assert(grp.length > 1, "treeview.PreservePreviousSelection : group length less than minimum (2)!")

                            if (grp.charAt(0) != prevGrp.charAt(0)) {
                                continue
                            }

                            if (grp.charAt(1) != prevGrp.charAt(1)) {
                                continue
                            }

                            // A matching group has been found
                            lev1 = i
                            deapth = 1
                        }

                        if ((tree[i].GetLevel() == 2) && (deapth == 1)) {
                            const grp = tree[i].GetGroupID()

                            Assert(grp.length > 3, "treeview.PreservePreviousSelection : group length less than minimum (4)!")

                            if (grp.charAt(0) != prevGrp.charAt(0)) {
                                continue
                            }

                            if (grp.charAt(1) != prevGrp.charAt(1)) {
                                continue
                            }

                            if (grp.charAt(2) != prevGrp.charAt(2)) {
                                continue
                            }

                            if (grp.charAt(3) != prevGrp.charAt(3)) {
                                continue
                            }

                            // A matching group has been found
                            lev2 = i
                            deapth = 2
                        }

                        if ((tree[i].GetLevel() == 3) && (deapth == 2)) {
                            const grp = tree[i].GetGroupID()

                            Assert(grp.length > 6, "treeview.PreservePreviousSelection : group length less than minimum (7)!")

                            if (grp.charAt(0) != prevGrp.charAt(0)) {
                                continue
                            }

                            if (grp.charAt(1) != prevGrp.charAt(1)) {
                                continue
                            }

                            if (grp.charAt(2) != prevGrp.charAt(2)) {
                                continue
                            }

                            if (grp.charAt(3) != prevGrp.charAt(3)) {
                                continue
                            }

                            if (grp.charAt(4) != prevGrp.charAt(4)) {
                                continue
                            }

                            if (grp.charAt(5) != prevGrp.charAt(5)) {
                                continue
                            }

                            if (grp.charAt(6) != prevGrp.charAt(6)) {
                                continue
                            }

                            // A matching group has been found
                            lev3 = i
                            deapth = 3
                        }
                    }

                    PADebug.Log("TreeView.PreservePreviousSelection - m_searchUpdatePending:" + this.m_searchUpdatePending.toString() + " is set to 12")
                    this.m_searchUpdatePending = 12
                    this.setState({ hasDerivedFromPreviousSelection: true, expandedItemL1: lev1, expandedItemL2: lev2, expandedItemL3: lev3, showingAtLevel: deapth })
                }
                else {
                    // tree was undefined, no action taken
                }
            }
        }
    }

    // This will expand the corresponding tree items according to the nobb group of a selected article
    public ExpandBySelection(nobbGroup: string) {
        var lev1 = -1
        var lev2 = -1
        var lev3 = -1

        if (nobbGroup.length != 7) {
            Assert(false, "TreeView.ExpandBySelection  : THe length of the nobbgroup was unexpected (not 7 characters long) :" + nobbGroup )
            return
        }

        if (this.props.app.GetCore().GetTreeIsAlphabetical() == true) {
            var tree = this.props.app.GetCore().GetAlphabeticalGroups(false)
            
            if (tree != undefined) {

                for (var i = 0; i < tree.length; i++) {
                    const grp = tree[i].GetGroupID()

                    if (grp.length < 7) {
                        break
                    }

                    if (grp.charAt(0) != nobbGroup.charAt(0)) {
                        continue
                    }

                    if (grp.charAt(1) != nobbGroup.charAt(1)) {
                        continue
                    }

                    if (grp.charAt(2) != nobbGroup.charAt(2)) {
                        continue
                    }

                    if (grp.charAt(3) != nobbGroup.charAt(3)) {
                        continue
                    }

                    if (grp.charAt(4) != nobbGroup.charAt(4)) {
                        continue
                    }

                    if (grp.charAt(5) != nobbGroup.charAt(5)) {
                        continue
                    }

                    if (grp.charAt(6) != nobbGroup.charAt(6)) {
                        continue
                    }

                    // A matching group has been found
                    lev1 = i
                }
                
                this.setState({ expandedItemL1: lev1, showingAtLevel: 1 })
            }
        }
        else {
            var tree = this.props.app.GetCore().GetHierarchialGroups()
            if (tree != undefined) {

                var deapth = 0

                for (var i = 0; i < tree.length; i++) {

                    if ((tree[i].GetLevel() == 1) && (deapth == 0)) {
                        const grp = tree[i].GetGroupID()

                        Assert(grp.length > 1, "treeview.PreservePreviousSelection : group length less than minimum (2)!")

                        if (grp.charAt(0) != nobbGroup.charAt(0)) {
                            continue
                        }

                        if (grp.charAt(1) != nobbGroup.charAt(1)) {
                            continue
                        }

                        // A matching group has been found
                        lev1 = i
                        deapth = 1
                    }

                    if ((tree[i].GetLevel() == 2) && (deapth == 1)) {
                        const grp = tree[i].GetGroupID()

                        Assert(grp.length > 3, "treeview.PreservePreviousSelection : group length less than minimum (4)!")

                        if (grp.charAt(0) != nobbGroup.charAt(0)) {
                            continue
                        }

                        if (grp.charAt(1) != nobbGroup.charAt(1)) {
                            continue
                        }

                        if (grp.charAt(2) != nobbGroup.charAt(2)) {
                            continue
                        }

                        if (grp.charAt(3) != nobbGroup.charAt(3)) {
                            continue
                        }

                        // A matching group has been found
                        lev2 = i
                        deapth = 2
                    }

                    if ((tree[i].GetLevel() == 3) && (deapth == 2)) {
                        const grp = tree[i].GetGroupID()

                        Assert(grp.length > 6, "treeview.PreservePreviousSelection : group length less than minimum (7)!")

                        if (grp.charAt(0) != nobbGroup.charAt(0)) {
                            continue
                        }

                        if (grp.charAt(1) != nobbGroup.charAt(1)) {
                            continue
                        }

                        if (grp.charAt(2) != nobbGroup.charAt(2)) {
                            continue
                        }

                        if (grp.charAt(3) != nobbGroup.charAt(3)) {
                            continue
                        }

                        if (grp.charAt(4) != nobbGroup.charAt(4)) {
                            continue
                        }

                        if (grp.charAt(5) != nobbGroup.charAt(5)) {
                            continue
                        }

                        if (grp.charAt(6) != nobbGroup.charAt(6)) {
                            continue
                        }

                        // A matching group has been found
                        lev3 = i
                        deapth = 3
                    }
                }
                
                this.setState({ expandedItemL1: lev1, expandedItemL2: lev2, expandedItemL3: lev3, showingAtLevel: deapth })
            }
        }
    }

    // SearchUpdatePulse will wait for the currently selected nobbgroup to be loaded and then update the search results upon that group
    public SearchUpdatePulse() {
        PADebug.Log("TreeView.SearchUpdatePulse - m_searchUpdatePending:" + this.m_searchUpdatePending.toString())
        if (this.m_searchUpdatePending > 0) {
            this.m_searchUpdatePending--

            // If the mode has changed or was not search results, this process terminates
            if (this.props.app.state.DisplayMode != this.props.app.DMode.SearchResult) {
                this.m_searchUpdatePending = 0
                return
            }

            var lastgrp = this.props.app.GetCore().GetLastSelectedGroup()
            if (lastgrp.length < 2) {
                this.m_searchUpdatePending = 0
                return
            }

            // if the selected group in the tree is loaded and ready, the most recent search call will be reposted, otherwise there's a postpone.. 
            if (this.props.app.GetCore().isGroupLoaded(lastgrp)) {
                this.m_searchUpdatePending = 0
                this.props.app.RePostSearchCall()
            }
            else {
                setTimeout(this.SearchUpdatePulse.bind(this), 200)
            }
        }
    }
    
    // a help function for the tree generation algorithm 
    isExpanded(level: number, id: number) {
        if ((level == 1) && (id == this.state.expandedItemL1)) {
            return true
        }

        if ((level == 2) && (id == this.state.expandedItemL2)) {
            return true
        }

        if ((level == 3) && (id == this.state.expandedItemL3)) {
            return true
        }

        if ((level == 4) && (id == this.state.expandedItemL4)) {
            return true
        }

        if ((level == 5) && (id == this.state.expandedItemL5)) {
            return true
        }

        return false
    }

    render() {
        if (this.state.hasDerivedFromPreviousSelection == false) {
            setTimeout(this.PreservePreviousSelection.bind(this), 60)
        }

        // There should always be an active state or url to read from, any lack of it will be displayed for debug purposes.
        if (this.state.treeSource == null) {
            return <div>(null)</div>
        }

        if (this.state.treeSource == undefined) {
            return <div>(undefined)</div>
        }
        
        var itemWidth = this.props.itemWidth // deriving the height and width from the treeview settings
        var itemHeight = this.props.itemHeight // deriving the height and width from the treeview settings
        var application = this.props.app // App reference to be inserted into the generated tree items as a property

        /* Next up, we are going to generate the tree to be shown, What kind of tree to display is determined by the
           state treeSource, which in the end will be used to control what tree type should be displayed. */

        var treeToBeShown = <div></div> // Holder for the resulting tree to be shown later (by default an empty div)

        if (this.props.app.GetCore().GetTreeIsAlphabetical() == true) {
            treeToBeShown = this.props.app.GetCore().RenderAlphabeticalTree(this, itemWidth, itemHeight) 
        } 
        else {
            treeToBeShown = this.props.app.GetCore().RenderHierarchyTree(this, itemWidth, itemHeight) 
        }

        return treeToBeShown
    }
}



// WEBPACK FOOTER //
// ./client/view/TreeViewGW.tsx